import React from 'react';
import { Box, Container } from '@mui/material';

import Achivements from './Achivements';
import UserDetails from './UserDetails';
import Projects from './Projects';

const Profile = ({ data }) => {
  return (
    <Box component={Container}>
      <UserDetails data={data?.userDetail} />
      {data?.achivement && <Achivements data={data?.achivement} />}
      {data?.learnerProject && <Projects data={data?.learnerProject} />}
    </Box>
  );
};

export default Profile;
